import { DateInput } from "~/components/datetime";
import { formatPickerDateForDisplay, parseIfDateString } from "~/utils/datetime";

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: React.ReactNode;
  description?: React.ReactNode;
};

/**
 * Opt-in PDF modals store calendar dates as display strings.
 * DateInput binds without changing transport shape.
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md
 */
export const OptInOrderDocumentStringDateInput = ({ label, value, onChange, error, description }: Props) => (
  <DateInput
    label={label}
    description={description}
    clearable
    weekendWarning
    value={value.trim() ? parseIfDateString(value) : null}
    onChange={date => onChange(date ? formatPickerDateForDisplay(date) : "")}
    error={error}
  />
);
